 import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer"
import "../styles/terms.css"
 import '../styles/bookingSection.css';
import { useEffect, useRef } from "react";
import Nav from "../components/Nav";

const Terms = () => {
  const navigate = useNavigate();

    const handleContactBtn = () => {
  navigate("/get-in-touch")
}

   const servicesRef = useRef(null);
      
   useEffect (() => {
    const revealElements = servicesRef.current.querySelectorAll("[data-reveal]");
     const scrollReveal = () => {
        for (let i = 0; i < revealElements.length; i++) {
         const elementIsInScreen =
        revealElements[i].getBoundingClientRect().top < window.innerHeight / 1.15;
      
      if (elementIsInScreen) {
       revealElements[i].classList.add("revealed");
       } else {
          revealElements[i].classList.remove("revealed");
           }
        }
       };
      
       window.addEventListener("scroll", scrollReveal);
          scrollReveal(); // Initial check
      
          return () => {
            window.removeEventListener("scroll", scrollReveal);
          };
        }, []);

  return (
    <>
    <div className="home__wrapper">
         <Nav/>
<div className='terms-wrapper '>
    
    <div className="terms-container">
      <h1>Terms & Conditions</h1>

      <p>These Terms and Conditions ("Terms") govern the provision of services by Roarz Kreatives ("Roarz", "we", "us", or "our") to the client ("Client" or "you"). By engaging our services and upon payment of the invoice, you agree to be bound by these Terms.</p>

      <h2>1. Services Offered</h2>
      <p>Roarz Kreatives provides a range of creative and marketing services, including but not limited to:</p>
      <ul>
        <li>Digital Marketing</li>
        <li>Website Design & Development</li>
        <li>Graphic Design</li>
        <li>Branding</li>
        <li>Video Production</li>
        <li>Photography</li>
        <li>Marketing & Strategy Services</li>
      </ul>

      <h2>2. Scope of Work</h2>
      <p>A detailed Scope of Work ("SOW") will be provided for each project, outlining specific services, deliverables, timelines, and costs. Any additional work outside the agreed SOW will require a separate agreement and may incur additional charges.</p>

      <h2>3. Payment Terms</h2>
      <ul>
        <li><strong>Deposits:</strong> A non-refundable deposit of 50% of the total project cost is required to commence work. For new clients, full payment may be requested upfront.</li>
        <li><strong>Final Payment:</strong> The remaining balance is due upon first draft of the project or as per the milestones outlined in the SOW. Late payments may incur interest charges.</li>
        <li><strong>Ad Spend & Third-Party Costs:</strong> Any costs related to advertising spend, printing, or third-party services must be paid in advance and are not included in project quotes unless explicitly stated.</li>
      </ul>

      <h2>4. Client Responsibilities</h2>
      <ul>
        <li><strong>Timely Communication:</strong> Clients must provide timely feedback and required materials to avoid project delays.</li>
        <li><strong>Provision of Assets:</strong> Clients are responsible for supplying all necessary assets (e.g., text, images). If not provided, Roarz can source these at an additional cost.</li>
        <li><strong>Approval of Work:</strong> Clients are responsible for reviewing and approving all deliverables. Approval signifies acceptance of the work as complete and satisfactory.</li>
      </ul>

      <h2>5. Revisions and Changes</h2>
      <p>The project includes a specified number of revision rounds as detailed in the SOW. Additional revisions or changes beyond the agreed scope will be quoted and billed separately.</p>

      <h2>6. No Refund Policy</h2>
      <p><strong>All Sales Final:</strong> Once the quote is accepted and terms are agreed upon, all sales are final. No refunds will be provided for change of mind. This policy is subject to applicable Kenyan law, including consumer protection provisions where they apply.</p>
      <p><strong>Project Approval:</strong> If a client approves a project (e.g., a website design) and subsequently changes their mind, the full remaining balance of the project fee is due immediately.</p>

      <h2>7. Retainer Agreements</h2>
      <p>Any retainer agreements (e.g., monthly support or marketing retainers) will have their terms specified in the associated agreement. Early termination by the client may require payment of remaining committed fees as set out in the retainer agreement.</p>

      <h2>8. Weather Conditions for Video and Photo Shoots</h2>
      <p>Video and photography services cannot be carried out in wet or unsafe weather conditions. In such cases, sessions will be rescheduled at a mutually agreed time without additional charges, unless non-refundable third-party costs have been incurred.</p>

      <h2>9. No Guarantees on Sales or Marketing Outcomes</h2>
      <p>Roarz Kreatives does not guarantee specific sales, conversions or marketing outcomes. Results vary depending on many external factors beyond our control.</p>

      <h2>10. Intellectual Property Rights</h2>
      <ul>
        <li><strong>Final Deliverables:</strong> Upon full payment, ownership of final deliverables transfers to the client, unless otherwise agreed in writing.</li>
        <li><strong>Source Files:</strong> All raw files, project files, and underlying source files remain the property of Roarz Kreatives unless otherwise agreed in writing.</li>
        <li><strong>Portfolio Use:</strong> Roarz reserves the right to showcase completed work in its portfolio and marketing materials unless a written confidentiality agreement or restriction is in place.</li>
      </ul>

      <h2>11. Limitation of Liability</h2>
      <p>Roarz Kreatives is not liable for any indirect, incidental, or consequential damages arising from the use of our services. Our total liability is limited to the amount paid by the client for the specific service in question, to the extent permitted by Kenyan law.</p>

      <h2>12. Confidentiality and Non-Disclosure</h2>
      <p>Both parties agree to keep confidential any proprietary or sensitive information shared during the course of the agreement. This obligation extends beyond the termination of the contract.</p>

      <h2>13. Dispute Resolution</h2>
      <p>In the event of a dispute, both parties agree to first attempt resolution through informal negotiations. If unresolved, the dispute will be referred to mediation before any legal proceedings are initiated.</p>

      <h2>14. Force Majeure</h2>
      <p>Neither party shall be liable for any failure or delay in performing their obligations under this agreement if such failure or delay is due to causes beyond their reasonable control (e.g., fire, floods, acts of God, governmental regulations, war, riots, strikes, pandemics). The affected party must notify the other in writing within 14 days of becoming aware of the force majeure event, detailing its nature and expected duration. Both parties shall use reasonable endeavours to mitigate the effects of the event. If the event continues for a period exceeding 90 days, either party may terminate the agreement upon written notice to the other.</p>

      <h2>15. Governing Law & Jurisdiction</h2>
      <p>These Terms are governed by the laws of Kenya. Any disputes arising from these Terms or our services will be subject to the exclusive jurisdiction of the courts of Kenya, unless the parties agree otherwise in writing.</p>

      <h2>16. Amendments</h2>
      <p>Roarz Kreatives reserves the right to amend these Terms at any time. Clients will be notified of significant changes, and continued use of our services constitutes acceptance of the updated Terms.</p>

      <h2>17. Acceptance of Terms</h2>
      <p>By engaging Roarz Kreatives' services and upon payment of the invoice, the client acknowledges having read, understood, and agreed to these Terms and Conditions.</p>

      <h2>18. Video & Photo Cancellation Policy</h2>
      <p>We require a minimum of 24 hours' notice to cancel or reschedule a booked video or photo shoot. Cancellations with less than 24 hours' notice may incur a fee of up to 100% of the scheduled shoot cost. If significant travel, equipment hire, or external bookings have already been made, any non-refundable costs will also be passed on.</p>

      <h2>19. Website Design, Development & Support Terms</h2>
      <p>Once a website has been approved and signed off by the client, any further changes, updates, or additions will be treated as new work and may incur additional charges. All change requests must be submitted via our official support system.</p>

      <h3>Support Services Terms</h3>
      <p><strong>In-Scope Support Works (no additional charge):</strong></p>
      <ul>
        <li>Server downtime issues</li>
        <li>Server configuration problems</li>
      </ul>

      <p><strong>Out-of-Scope Support Works (additional charges apply):</strong> All other services fall outside the scope of standard support and will incur additional fees at our published rates. Before starting any out-of-scope support work, we will provide an estimate and seek your approval. Invoices will be issued upon completion of work and are due upon receipt. Submission of a support request through our portal signifies acceptance of these terms.</p>

      <h2>20. Privacy & Data Protection</h2>
      <p>Roarz Kreatives may collect Personal Information about your representatives, your clients and others when we provide services to you. We will handle personal information in accordance with Kenyan data protection law, including the Data Protection Act, 2019. You agree to cooperate with us so that both parties meet any obligations under the Data Protection Act and related regulations (for example, regarding lawful basis for processing, notifications to data subjects, data security and transfer restrictions).</p>

      <h2>21. Consumer Rights</h2>
      <p>Where the Consumer Protection Act, 2012 or other Kenyan consumer law applies, clients will have rights that cannot be excluded by contract. Nothing in these Terms is intended to exclude or limit mandatory consumer rights under Kenyan law.</p>
       <h2>23. TikTok Lead Generation, CRM Integrations & Third-Party Platforms</h2>
<p>Roarz Kreatives may use third-party platforms and integrations, including social media platforms, advertising platforms, CRM systems, automation tools, and communication services, to collect, receive, process, organise, and respond to enquiries, leads, and customer communications. These may include, without limitation, TikTok Lead Generation, website forms, Meta platforms, WhatsApp, email services, analytics tools, and related integrations.</p>

<p>Where leads or customer information are submitted through TikTok or another third-party platform, you acknowledge and agree that such information may be transmitted to and processed by Roarz Kreatives and its service providers for the purposes of lead management, customer support, analytics, record-keeping, follow-up communication, and service delivery.</p>

<p>Clients who engage us to run campaigns, manage lead generation, or connect third-party services confirm that they have obtained all necessary rights, permissions, and lawful bases required for the collection and use of personal data submitted through those services, including where required under applicable data protection law.</p>

<p>Roarz Kreatives is not responsible for the privacy practices, platform availability, policy changes, account restrictions, or system outages of TikTok or any other third-party platform. Use of those platforms remains subject to the relevant third party's own terms, privacy notices, and platform rules.</p>

<h2>24. Platform Compliance and Acceptable Use</h2>
<p>Where our services involve integration with TikTok or any other third-party platform, the client agrees not to use our services, websites, forms, campaigns, or connected systems for any unlawful, misleading, fraudulent, harmful, or prohibited activity. The client further agrees not to submit, request, or process data in a manner that violates any applicable law, advertising policy, developer policy, platform term, or the rights of any third party.</p>

<p>Roarz Kreatives reserves the right to suspend, refuse, limit, or terminate any integration, campaign support, or related service where we reasonably believe that use of the relevant platform, data, or connected systems may breach applicable laws, platform policies, or these Terms.</p>

<h2>25. Data Submitted Through Forms and Connected Systems</h2>
<p>Information submitted through website contact forms, lead forms, booking forms, TikTok instant forms, CRM integrations, or similar tools may include names, phone numbers, email addresses, business information, and message content. By submitting such information, the submitting party confirms that the information provided is accurate and that they consent, where required by law, to being contacted in relation to their enquiry, requested service, or expressed interest.</p>

<p>Roarz Kreatives may use such information to respond to enquiries, provide quotations, deliver services, improve operations, maintain business records, and communicate by phone, email, WhatsApp, SMS, or other reasonable channels, subject to applicable law.</p>

<h2>26. Reference to Privacy Policy</h2>
<p>Our Privacy Policy explains in more detail how we collect, use, store, disclose, and protect personal data, including data received through TikTok lead forms, website forms, CRM tools, and related integrations. By using our website or submitting information to us, you also acknowledge our Privacy Policy as updated from time to time.</p>
      <h2>27. Contact</h2>
      <p>For questions about these Terms & Conditions, please contact us at <a href="mailto:hello@roarzkreatives.com">hello@roarzkreatives.com</a>.</p>

      <footer>
        <p>Last updated: October 6, 2025</p>
      </footer>
    </div>
</div>
 
<section className="booking-wrapper" ref={servicesRef}>
  <div className="booking-content">
    <h3 data-reveal>Let's get to work</h3>
    <p data-reveal>Ready to get started? Book a Discovery Call so we can learn more about your needs and discuss how we can help.</p>
    <button  className="get-started-btn" onClick={handleContactBtn}>
      Get Started <span className="plus-icon">+</span>
    </button>
  </div>
   
</section>

<Footer/>
    </div>

    </>

  )
}

export default Terms
